import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { CaseStudies } from './pages/CaseStudies';
import { About } from './pages/About';
import { BookCall } from './pages/BookCall';
import { WhoWeServe } from './pages/WhoWeServe';
import { Terms } from './pages/Terms';
import { Terms26 } from './pages/Terms26';
import { Privacy } from './pages/Privacy';
import { WindowsCaseStudy } from './pages/WindowsCaseStudy';
import { MeetingsFlow } from './pages/onboarding/MeetingsFlow';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - only initialize once
    if (window.fbq) {
      return;
    }
    // Initialize fbq function and queue before loading script
    window.fbq = function () {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel after script setup
    window.fbq('init', '878753891400350');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Routes data-id="element-2">
          {/* Hidden pages - no header/footer */}
          <Route path="/windows-case-study" element={<WindowsCaseStudy data-id="element-4" />} data-id="element-3" />
          <Route path="/onboarding/meetings" element={<MeetingsFlow data-id="element-6" />} data-id="element-5" />

          {/* Regular pages with header/footer */}
          <Route path="/*" element={<>
                <Header data-id="element-8" />
                <main className="flex-grow" data-id="element-9">
                  <Routes data-id="element-10">
                    <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
                    <Route path="/how-it-works" element={<HowItWorks data-id="element-14" />} data-id="element-13" />
                    <Route path="/case-studies" element={<CaseStudies data-id="element-16" />} data-id="element-15" />
                    <Route path="/about" element={<About data-id="element-18" />} data-id="element-17" />
                    <Route path="/book-call" element={<BookCall data-id="element-20" />} data-id="element-19" />
                    <Route path="/who-we-serve" element={<WhoWeServe data-id="element-22" />} data-id="element-21" />
                    <Route path="/terms" element={<Terms data-id="element-24" />} data-id="element-23" />
                    <Route path="/terms26" element={<Terms26 data-id="element-26" />} data-id="element-25" />
                    <Route path="/privacy" element={<Privacy data-id="element-28" />} data-id="element-27" />
                  </Routes>
                </main>
                <Footer data-id="element-29" />
              </>} data-id="element-7" />
        </Routes>
      </div>
    </BrowserRouter>;
}